import { render, staticRenderFns } from "./SetOverview.vue?vue&type=template&id=7bf377d0&scoped=true"
import script from "./SetOverview.vue?vue&type=script&lang=ts"
export * from "./SetOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf377d0",
  null
  
)

export default component.exports